import React from 'react';

import { TextField, makeStyles, MenuItem } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const useStyles = makeStyles(() => ({
  selectCurrencyMenuItem: {
    color: '#6D7D8B',
    fontWeight: '500',
    fontSize: '13px',
    lineHeight: '16px',
    borderBottom: '0.5px solid #DDDFDF',
    padding: '0.8rem 0.3rem',
  },
}));

export default function SelectBox(props) {
  const classes = useStyles();

  const menuComponent = (options) => {
    return options?.map((option) => (
      <MenuItem
        className={classes.selectCurrencyMenuItem}
        key={option?.id}
        value={
          option?.value || option?.symbol || option?.isoCode || option.name
        }
      >
        {option?.label || option?.name}
      </MenuItem>
    ));
  };

  return (
    <>
      <label className={props.inputlabel} htmlFor={props.htmlFor}>
        {`${props.labeltext}*`}
      </label>

      <TextField
        className={`selectCurrencyDropdown ${props.from_field}`}
        select
        id='selectbox'
        margin='none'
        onChange={props.handleChange}
        {...props}
        placeholder='This'
        disabled={props?.disabled}
        // IconComponent={() => <Person />}
        // SelectProps={{
        //   IconComponent: () => <ExpandMoreIcon />,
        // }}
        IconComponent={() => <ExpandMoreIcon />}
      >
        {menuComponent(props?.options)}
      </TextField>
    </>
  );
}
